// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { LobbyVision2LiftNumSource } from "./lobby-vision2-lift-num-source";

/**
 * Per-adapter addressing configuration.
 *
 * One scheme governs the whole adapter (LV2 wire addressing is a property
 * of the vendor controller/protocol, not of an individual message). All
 * fields defaulted so an un-configured template behaves as classic 1-based
 * index addressing.
 */
export class LobbyVision2AddressingConfig implements flatbuffers.IUnpackableObject<LobbyVision2AddressingConfigT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): LobbyVision2AddressingConfig {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsLobbyVision2AddressingConfig(
    bb: flatbuffers.ByteBuffer,
    obj?: LobbyVision2AddressingConfig,
  ): LobbyVision2AddressingConfig {
    return (obj || new LobbyVision2AddressingConfig()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsLobbyVision2AddressingConfig(
    bb: flatbuffers.ByteBuffer,
    obj?: LobbyVision2AddressingConfig,
  ): LobbyVision2AddressingConfig {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new LobbyVision2AddressingConfig()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  /**
   * Selects the `units_based` `lift_num` derivation. Default `IndexBased`.
   */
  liftNumSource(): LobbyVision2LiftNumSource {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : LobbyVision2LiftNumSource.IndexBased;
  }

  /**
   * Base added to `car_index` when `lift_num_source` = `IndexBased`.
   * 1 => `bank.Lifts[0]` -> `lift_num` 1 (classic). 0 => 0-based. Any uint8 OK.
   */
  liftNumBase(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : 1;
  }

  /**
   * Sentinel `lift_num` emitted for `bank_level` entries (whole-bank telegraph).
   */
  bankLiftNum(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : 0;
  }

  /**
   * Floor->`data` derivation for `floors_based` entries:
   *   `data` = `floor_data_base` + (`floor_index` * `floor_data_step`)
   *          + (`apply_vendor_floor_offset` ? `Cdo.vendor_floor_offset` : 0)
   */
  floorDataBase(): number {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : 0;
  }

  floorDataStep(): number {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : 1;
  }

  /**
   * When true, add `Cdo.vendor_floor_offset` (cdo.fbs) to the floor `data`.
   */
  applyVendorFloorOffset(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  static startLobbyVision2AddressingConfig(builder: flatbuffers.Builder) {
    builder.startObject(6);
  }

  static addLiftNumSource(builder: flatbuffers.Builder, liftNumSource: LobbyVision2LiftNumSource) {
    builder.addFieldInt8(0, liftNumSource, LobbyVision2LiftNumSource.IndexBased);
  }

  static addLiftNumBase(builder: flatbuffers.Builder, liftNumBase: number) {
    builder.addFieldInt8(1, liftNumBase, 1);
  }

  static addBankLiftNum(builder: flatbuffers.Builder, bankLiftNum: number) {
    builder.addFieldInt8(2, bankLiftNum, 0);
  }

  static addFloorDataBase(builder: flatbuffers.Builder, floorDataBase: number) {
    builder.addFieldInt8(3, floorDataBase, 0);
  }

  static addFloorDataStep(builder: flatbuffers.Builder, floorDataStep: number) {
    builder.addFieldInt8(4, floorDataStep, 1);
  }

  static addApplyVendorFloorOffset(builder: flatbuffers.Builder, applyVendorFloorOffset: boolean) {
    builder.addFieldInt8(5, +applyVendorFloorOffset, +false);
  }

  static endLobbyVision2AddressingConfig(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createLobbyVision2AddressingConfig(
    builder: flatbuffers.Builder,
    liftNumSource: LobbyVision2LiftNumSource,
    liftNumBase: number,
    bankLiftNum: number,
    floorDataBase: number,
    floorDataStep: number,
    applyVendorFloorOffset: boolean,
  ): flatbuffers.Offset {
    LobbyVision2AddressingConfig.startLobbyVision2AddressingConfig(builder);
    LobbyVision2AddressingConfig.addLiftNumSource(builder, liftNumSource);
    LobbyVision2AddressingConfig.addLiftNumBase(builder, liftNumBase);
    LobbyVision2AddressingConfig.addBankLiftNum(builder, bankLiftNum);
    LobbyVision2AddressingConfig.addFloorDataBase(builder, floorDataBase);
    LobbyVision2AddressingConfig.addFloorDataStep(builder, floorDataStep);
    LobbyVision2AddressingConfig.addApplyVendorFloorOffset(builder, applyVendorFloorOffset);
    return LobbyVision2AddressingConfig.endLobbyVision2AddressingConfig(builder);
  }

  unpack(): LobbyVision2AddressingConfigT {
    return new LobbyVision2AddressingConfigT(
      this.liftNumSource(),
      this.liftNumBase(),
      this.bankLiftNum(),
      this.floorDataBase(),
      this.floorDataStep(),
      this.applyVendorFloorOffset(),
    );
  }

  unpackTo(_o: LobbyVision2AddressingConfigT): void {
    _o.liftNumSource = this.liftNumSource();
    _o.liftNumBase = this.liftNumBase();
    _o.bankLiftNum = this.bankLiftNum();
    _o.floorDataBase = this.floorDataBase();
    _o.floorDataStep = this.floorDataStep();
    _o.applyVendorFloorOffset = this.applyVendorFloorOffset();
  }

  unpackFields(...fields: string[]): LobbyVision2AddressingConfigT {
    const t = new LobbyVision2AddressingConfigT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("lift_num_source")) {
      t.liftNumSource = this.liftNumSource();
    }
    if (fieldSet.has("lift_num_base")) {
      t.liftNumBase = this.liftNumBase();
    }
    if (fieldSet.has("bank_lift_num")) {
      t.bankLiftNum = this.bankLiftNum();
    }
    if (fieldSet.has("floor_data_base")) {
      t.floorDataBase = this.floorDataBase();
    }
    if (fieldSet.has("floor_data_step")) {
      t.floorDataStep = this.floorDataStep();
    }
    if (fieldSet.has("apply_vendor_floor_offset")) {
      t.applyVendorFloorOffset = this.applyVendorFloorOffset();
    }
    return t;
  }
}

export class LobbyVision2AddressingConfigT implements flatbuffers.IGeneratedObject {
  constructor(
    public liftNumSource: LobbyVision2LiftNumSource = LobbyVision2LiftNumSource.IndexBased,
    public liftNumBase: number = 1,
    public bankLiftNum: number = 0,
    public floorDataBase: number = 0,
    public floorDataStep: number = 1,
    public applyVendorFloorOffset: boolean = false,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    return LobbyVision2AddressingConfig.createLobbyVision2AddressingConfig(
      builder,
      this.liftNumSource,
      this.liftNumBase,
      this.bankLiftNum,
      this.floorDataBase,
      this.floorDataStep,
      this.applyVendorFloorOffset,
    );
  }

  clone(): LobbyVision2AddressingConfigT {
    const obj = new LobbyVision2AddressingConfigT();
    obj.liftNumSource = this.liftNumSource;
    obj.liftNumBase = this.liftNumBase;
    obj.bankLiftNum = this.bankLiftNum;
    obj.floorDataBase = this.floorDataBase;
    obj.floorDataStep = this.floorDataStep;
    obj.applyVendorFloorOffset = this.applyVendorFloorOffset;
    return obj;
  }

  equals(other: LobbyVision2AddressingConfigT): boolean {
    if (this.liftNumSource !== other.liftNumSource) return false;
    if (this.liftNumBase !== other.liftNumBase) return false;
    if (this.bankLiftNum !== other.bankLiftNum) return false;
    if (this.floorDataBase !== other.floorDataBase) return false;
    if (this.floorDataStep !== other.floorDataStep) return false;
    if (this.applyVendorFloorOffset !== other.applyVendorFloorOffset) return false;
    return true;
  }
}

export function verifyLobbyVision2AddressingConfig(
  verifier: flatbuffers.Verifier,
  tablePos: number,
): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 1);
    verifier.checkScalarField(tablePos, 6, 1);
    verifier.checkScalarField(tablePos, 8, 1);
    verifier.checkScalarField(tablePos, 10, 1);
    verifier.checkScalarField(tablePos, 12, 1);
    verifier.checkScalarField(tablePos, 14, 1);
  } finally {
    verifier.popDepth();
  }
}
